enum PaymentStatusTypes {
    ACKNOWLEDGE = 'ACKNOWLEDGE',
    FINALIZE = 'FINALIZE',
    INITIALIZE = 'INITIALIZE',
}

export default PaymentStatusTypes;
